// extracted by mini-css-extract-plugin
export default {"avatar":"PersonMetadata_avatar__2qb47","container":"PersonMetadata_container__Z1AEt","button":"PersonMetadata_button__BY8ge"};